
import { mapGetters } from "vuex";
export default {
	data() {
        return{
            show_pop_up: false
        };
	},
	async mounted() {
        setTimeout(() => {

            this.show_pop_up = true;
        }, 600);
	},
	computed: {
		...mapGetters({
			getterLogin: 'getterLogin',
            getterBasicData: 'getterBasicData',
		}),
        getShowPopUp(){
            return this.show_pop_up;
        },
        getPhoneWhatsapp(){
            return this.getterBasicData?.contact_information.phones.find( (item) => item.whatsapp );
        }
	}
}
